export default __webpack_public_path__ + "static/media/gamestack-list.8f1de0b0.jpg";